import type { SVGProps } from 'react'

export const Kanban = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="80"
    viewBox="0 0 81 80"
    width="81"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.5 58C23.7091 58 25.5 59.7909 25.5 62V72C25.5 74.2091 23.7091 76 21.5 76H7.5C5.29086 76 3.5 74.2091 3.5 72V62C3.5 59.7909 5.29086 58 7.5 58H21.5ZM21.5 36C23.7091 36 25.5 37.7909 25.5 40V50C25.5 52.2091 23.7091 54 21.5 54H7.5C5.29086 54 3.5 52.2091 3.5 50V40C3.5 37.7909 5.29086 36 7.5 36H21.5ZM47.5 36C49.7091 36 51.5 37.7909 51.5 40V50C51.5 52.2091 49.7091 54 47.5 54H33.5C31.2909 54 29.5 52.2091 29.5 50V40C29.5 37.7909 31.2909 36 33.5 36H47.5ZM73.5 36C75.7091 36 77.5 37.7909 77.5 40V50C77.5 52.2091 75.7091 54 73.5 54H59.5C57.2909 54 55.5 52.2091 55.5 50V40C55.5 37.7909 57.2909 36 59.5 36H73.5ZM21.5 14C23.7091 14 25.5 15.7909 25.5 18V28C25.5 30.2091 23.7091 32 21.5 32H7.5C5.29086 32 3.5 30.2091 3.5 28V18C3.5 15.7909 5.29086 14 7.5 14H21.5ZM47.5 14C49.7091 14 51.5 15.7909 51.5 18V28C51.5 30.2091 49.7091 32 47.5 32H33.5C31.2909 32 29.5 30.2091 29.5 28V18C29.5 15.7909 31.2909 14 33.5 14H47.5ZM73.5 14C75.7091 14 77.5 15.7909 77.5 18V28C77.5 30.2091 75.7091 32 73.5 32H59.5C57.2909 32 55.5 30.2091 55.5 28V18C55.5 15.7909 57.2909 14 59.5 14H73.5Z"
      fill="url(#paint0_linear_2961_11646)"
    />
    <path
      d="M3.5 7C3.5 5.34315 4.84315 4 6.5 4H22.5C24.1569 4 25.5 5.34315 25.5 7C25.5 8.65685 24.1569 10 22.5 10H6.5C4.84315 10 3.5 8.65685 3.5 7Z"
      fill="url(#paint1_linear_2961_11646)"
    />
    <path
      d="M29.5 7C29.5 5.34315 30.8431 4 32.5 4H48.5C50.1569 4 51.5 5.34315 51.5 7C51.5 8.65685 50.1569 10 48.5 10H32.5C30.8431 10 29.5 8.65685 29.5 7Z"
      fill="url(#paint2_linear_2961_11646)"
    />
    <path
      d="M55.5 7C55.5 5.34315 56.8431 4 58.5 4H74.5C76.1569 4 77.5 5.34315 77.5 7C77.5 8.65685 76.1569 10 74.5 10H58.5C56.8431 10 55.5 8.65685 55.5 7Z"
      fill="url(#paint3_linear_2961_11646)"
    />
    <mask
      height="72"
      id="mask0_2961_11646"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha'
      }}
      width="75"
      x="3"
      y="4"
    >
      <path
        d="M21.5 58C23.7091 58 25.5 59.7909 25.5 62V72C25.5 74.2091 23.7091 76 21.5 76H7.5C5.29086 76 3.5 74.2091 3.5 72V62C3.5 59.7909 5.29086 58 7.5 58H21.5ZM21.5 36C23.7091 36 25.5 37.7909 25.5 40V50C25.5 52.2091 23.7091 54 21.5 54H7.5C5.29086 54 3.5 52.2091 3.5 50V40C3.5 37.7909 5.29086 36 7.5 36H21.5ZM47.5 36C49.7091 36 51.5 37.7909 51.5 40V50C51.5 52.2091 49.7091 54 47.5 54H33.5C31.2909 54 29.5 52.2091 29.5 50V40C29.5 37.7909 31.2909 36 33.5 36H47.5ZM73.5 36C75.7091 36 77.5 37.7909 77.5 40V50C77.5 52.2091 75.7091 54 73.5 54H59.5C57.2909 54 55.5 52.2091 55.5 50V40C55.5 37.7909 57.2909 36 59.5 36H73.5ZM21.5 14C23.7091 14 25.5 15.7909 25.5 18V28C25.5 30.2091 23.7091 32 21.5 32H7.5C5.29086 32 3.5 30.2091 3.5 28V18C3.5 15.7909 5.29086 14 7.5 14H21.5ZM47.5 14C49.7091 14 51.5 15.7909 51.5 18V28C51.5 30.2091 49.7091 32 47.5 32H33.5C31.2909 32 29.5 30.2091 29.5 28V18C29.5 15.7909 31.2909 14 33.5 14H47.5ZM73.5 14C75.7091 14 77.5 15.7909 77.5 18V28C77.5 30.2091 75.7091 32 73.5 32H59.5C57.2909 32 55.5 30.2091 55.5 28V18C55.5 15.7909 57.2909 14 59.5 14H73.5ZM22.5 4C24.1569 4 25.5 5.34315 25.5 7C25.5 8.65685 24.1569 10 22.5 10H6.5C4.84315 10 3.5 8.65685 3.5 7C3.5 5.34315 4.84315 4 6.5 4H22.5ZM48.5 4C50.1569 4 51.5 5.34315 51.5 7C51.5 8.65685 50.1569 10 48.5 10H32.5C30.8431 10 29.5 8.65685 29.5 7C29.5 5.34315 30.8431 4 32.5 4H48.5ZM74.5 4C76.1569 4 77.5 5.34315 77.5 7C77.5 8.65685 76.1569 10 74.5 10H58.5C56.8431 10 55.5 8.65685 55.5 7C55.5 5.34315 56.8431 4 58.5 4H74.5Z"
        fill="url(#paint4_linear_2961_11646)"
      />
    </mask>
    <g mask="url(#mask0_2961_11646)">
      <g filter="url(#filter0_f_2961_11646)">
        <path
          d="M32.5074 73C29.0887 73 25.858 72.3438 22.8152 71.0313C19.772 69.7188 17.1173 67.927 14.851 65.6558C12.5852 63.385 10.7935 60.7315 9.47611 57.6953C8.15871 54.6591 7.5 51.4318 7.5 48.0135C7.5 44.5538 8.15871 41.3142 9.47611 38.2949C10.7935 35.2751 12.5852 32.6298 14.851 30.359C17.1173 28.0878 19.772 26.2935 22.8152 24.9761C25.8584 23.6587 29.0895 23 32.5086 23C35.9536 23 39.1882 23.6587 42.2125 24.9761C45.2372 26.2935 47.8825 28.0878 50.1484 30.359C52.4146 32.6298 54.2065 35.2751 55.5239 38.2949C56.8413 41.3142 57.5 44.5522 57.5 48.0086C57.5 51.4318 56.8413 54.6611 55.5239 57.6965C54.2065 60.7319 52.4146 63.385 50.1484 65.6558C47.8825 67.927 45.236 69.7188 42.2088 71.0313C39.1821 72.3438 35.9483 73 32.5074 73Z"
          fill="url(#paint5_linear_2961_11646)"
          fillOpacity="0.5"
        />
      </g>
    </g>
    <mask
      height="18"
      id="mask1_2961_11646"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha'
      }}
      width="23"
      x="29"
      y="36"
    >
      <rect fill="#D9D9D9" height="18" width="22" x="29.5" y="36" />
    </mask>
    <g mask="url(#mask1_2961_11646)">
      <path
        d="M36.925 45.675C36.6913 45.675 36.4953 45.6107 36.3372 45.4821C36.1791 45.3534 36.1 45.1941 36.1 45.0039C36.1 44.8138 36.1791 44.6531 36.3372 44.5219C36.4953 44.3906 36.6913 44.325 36.925 44.325H44.075C44.3088 44.325 44.5047 44.3893 44.6628 44.5179C44.8209 44.6466 44.9 44.8059 44.9 44.9961C44.9 45.1862 44.8209 45.3469 44.6628 45.4781C44.5047 45.6094 44.3088 45.675 44.075 45.675H36.925Z"
        fill="#1C1B1F"
      />
    </g>
    <mask
      height="18"
      id="mask2_2961_11646"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha'
      }}
      width="23"
      x="55"
      y="36"
    >
      <rect fill="#D9D9D9" height="18" width="22" x="55.5" y="36" />
    </mask>
    <g mask="url(#mask2_2961_11646)">
      <path
        d="M63.25 45.75C63.0375 45.75 62.8594 45.6785 62.7156 45.5356C62.5719 45.3927 62.5 45.2156 62.5 45.0044C62.5 44.7931 62.5719 44.6146 62.7156 44.4688C62.8594 44.3229 63.0375 44.25 63.25 44.25H69.75C69.9625 44.25 70.1406 44.3215 70.2844 44.4644C70.4281 44.6073 70.5 44.7844 70.5 44.9956C70.5 45.2069 70.4281 45.3854 70.2844 45.5312C70.1406 45.6771 69.9625 45.75 69.75 45.75H63.25Z"
        fill="url(#paint6_linear_2961_11646)"
      />
    </g>
    <mask
      height="18"
      id="mask3_2961_11646"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha'
      }}
      width="23"
      x="55"
      y="14"
    >
      <rect fill="#D9D9D9" height="18" width="22" x="55.5" y="14" />
    </mask>
    <g mask="url(#mask3_2961_11646)">
      <path
        d="M64.8333 24.7396L69.9167 19.6563C70.0694 19.5035 70.2465 19.4271 70.4479 19.4271C70.6493 19.4271 70.8264 19.5035 70.9792 19.6563C71.1319 19.809 71.2083 19.9861 71.2083 20.1875C71.2083 20.3889 71.1319 20.566 70.9792 20.7188L65.3542 26.3438C65.2014 26.4965 65.0243 26.5729 64.8229 26.5729C64.6215 26.5729 64.4444 26.4965 64.2917 26.3438L62.0208 24.0729C61.868 23.9201 61.7917 23.7431 61.7917 23.5417C61.7917 23.3403 61.868 23.1632 62.0208 23.0104C62.1736 22.8576 62.3507 22.7813 62.5521 22.7813C62.7535 22.7813 62.9305 22.8576 63.0833 23.0104L64.8333 24.7396Z"
        fill="url(#paint7_linear_2961_11646)"
      />
    </g>
    <mask
      height="18"
      id="mask4_2961_11646"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha'
      }}
      width="23"
      x="29"
      y="14"
    >
      <rect fill="#D9D9D9" height="18" width="22" x="29.5" y="14" />
    </mask>
    <g mask="url(#mask4_2961_11646)">
      <path
        d="M38.8333 24.7396L43.9167 19.6563C44.0694 19.5035 44.2465 19.4271 44.4479 19.4271C44.6493 19.4271 44.8264 19.5035 44.9792 19.6563C45.1319 19.809 45.2083 19.9861 45.2083 20.1875C45.2083 20.3889 45.1319 20.566 44.9792 20.7188L39.3542 26.3438C39.2014 26.4965 39.0243 26.5729 38.8229 26.5729C38.6215 26.5729 38.4444 26.4965 38.2917 26.3438L36.0208 24.0729C35.868 23.9201 35.7917 23.7431 35.7917 23.5417C35.7917 23.3403 35.868 23.1632 36.0208 23.0104C36.1736 22.8576 36.3507 22.7813 36.5521 22.7813C36.7535 22.7813 36.9305 22.8576 37.0833 23.0104L38.8333 24.7396Z"
        fill="url(#paint8_linear_2961_11646)"
      />
    </g>
    <mask
      height="18"
      id="mask5_2961_11646"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha'
      }}
      width="23"
      x="3"
      y="14"
    >
      <rect fill="#D9D9D9" height="18" width="22" x="3.5" y="14" />
    </mask>
    <g mask="url(#mask5_2961_11646)">
      <path
        d="M12.8333 24.7396L17.9167 19.6563C18.0694 19.5035 18.2465 19.4271 18.4479 19.4271C18.6493 19.4271 18.8264 19.5035 18.9792 19.6563C19.1319 19.809 19.2083 19.9861 19.2083 20.1875C19.2083 20.3889 19.1319 20.566 18.9792 20.7188L13.3542 26.3438C13.2014 26.4965 13.0243 26.5729 12.8229 26.5729C12.6215 26.5729 12.4444 26.4965 12.2917 26.3438L10.0208 24.0729C9.86805 23.9201 9.79166 23.7431 9.79166 23.5417C9.79166 23.3403 9.86805 23.1632 10.0208 23.0104C10.1736 22.8576 10.3507 22.7813 10.5521 22.7813C10.7535 22.7813 10.9305 22.8576 11.0833 23.0104L12.8333 24.7396Z"
        fill="url(#paint9_linear_2961_11646)"
      />
    </g>
    <mask
      height="18"
      id="mask6_2961_11646"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha'
      }}
      width="23"
      x="3"
      y="36"
    >
      <rect fill="#D9D9D9" height="18" width="22" x="3.5" y="36" />
    </mask>
    <g mask="url(#mask6_2961_11646)">
      <path
        d="M12.8333 46.7396L17.9167 41.6563C18.0694 41.5035 18.2465 41.4271 18.4479 41.4271C18.6493 41.4271 18.8264 41.5035 18.9792 41.6563C19.1319 41.809 19.2083 41.9861 19.2083 42.1875C19.2083 42.3889 19.1319 42.566 18.9792 42.7188L13.3542 48.3438C13.2014 48.4965 13.0243 48.5729 12.8229 48.5729C12.6215 48.5729 12.4444 48.4965 12.2917 48.3438L10.0208 46.0729C9.86805 45.9201 9.79166 45.7431 9.79166 45.5417C9.79166 45.3403 9.86805 45.1632 10.0208 45.0104C10.1736 44.8576 10.3507 44.7813 10.5521 44.7813C10.7535 44.7813 10.9305 44.8576 11.0833 45.0104L12.8333 46.7396Z"
        fill="url(#paint10_linear_2961_11646)"
      />
    </g>
    <mask
      height="18"
      id="mask7_2961_11646"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha'
      }}
      width="23"
      x="3"
      y="58"
    >
      <rect fill="#D9D9D9" height="18" width="22" x="3.5" y="58" />
    </mask>
    <g mask="url(#mask7_2961_11646)">
      <path
        d="M11.25 67.75C11.0375 67.75 10.8594 67.6785 10.7156 67.5356C10.5719 67.3927 10.5 67.2156 10.5 67.0044C10.5 66.7931 10.5719 66.6146 10.7156 66.4688C10.8594 66.3229 11.0375 66.25 11.25 66.25H17.75C17.9625 66.25 18.1406 66.3215 18.2844 66.4644C18.4281 66.6073 18.5 66.7844 18.5 66.9956C18.5 67.2069 18.4281 67.3854 18.2844 67.5312C18.1406 67.6771 17.9625 67.75 17.75 67.75H11.25Z"
        fill="url(#paint11_linear_2961_11646)"
      />
    </g>
    <foreignObject height="64" width="64" x="8.5" y="12">
      <div
        style={{
          backdropFilter: 'blur(3.5px)',
          clipPath: 'url(#bgblur_0_2961_11646_clip_path)',
          height: '100%',
          width: '100%'
        }}
      ></div>
    </foreignObject>
    <g data-figma-bg-blur-radius="7">
      <mask fill="white" id="path-21-inside-1_2961_11646">
        <path d="M40.4991 69C37.0352 69 33.789 68.3487 30.7607 67.046C27.7323 65.743 25.0832 63.9565 22.8133 61.6867C20.5435 59.4168 18.757 56.7663 17.454 53.7351C16.1513 50.7035 15.5 47.4542 15.5 43.987C15.5 40.5199 16.1513 37.2705 17.454 34.2389C18.757 31.2078 20.5435 28.5673 22.8133 26.3175C25.0832 24.0678 27.7337 22.2858 30.7649 20.9715C33.7965 19.6572 37.0458 19 40.513 19C43.9801 19 47.2295 19.6572 50.2611 20.9715C53.2922 22.2858 55.9327 24.0678 58.1825 26.3175C60.4322 28.5673 62.2142 31.211 63.5285 34.2486C64.8428 37.2866 65.5 40.5374 65.5 44.0009C65.5 47.4648 64.8428 50.711 63.5285 53.7393C62.2142 56.7677 60.4322 59.4132 58.1825 61.6758C55.9327 63.938 53.289 65.7243 50.2514 67.0346C47.2134 68.3449 43.9626 69 40.4991 69Z" />
      </mask>
      <path
        d="M40.4991 69C37.0352 69 33.789 68.3487 30.7607 67.046C27.7323 65.743 25.0832 63.9565 22.8133 61.6867C20.5435 59.4168 18.757 56.7663 17.454 53.7351C16.1513 50.7035 15.5 47.4542 15.5 43.987C15.5 40.5199 16.1513 37.2705 17.454 34.2389C18.757 31.2078 20.5435 28.5673 22.8133 26.3175C25.0832 24.0678 27.7337 22.2858 30.7649 20.9715C33.7965 19.6572 37.0458 19 40.513 19C43.9801 19 47.2295 19.6572 50.2611 20.9715C53.2922 22.2858 55.9327 24.0678 58.1825 26.3175C60.4322 28.5673 62.2142 31.211 63.5285 34.2486C64.8428 37.2866 65.5 40.5374 65.5 44.0009C65.5 47.4648 64.8428 50.711 63.5285 53.7393C62.2142 56.7677 60.4322 59.4132 58.1825 61.6758C55.9327 63.938 53.289 65.7243 50.2514 67.0346C47.2134 68.3449 43.9626 69 40.4991 69Z"
        fill="url(#paint12_linear_2961_11646)"
        fillOpacity="0.4"
      />
      <g
        clipPath="url(#paint13_angular_2961_11646_clip_path)"
        data-figma-skip-parse="true"
        mask="url(#path-21-inside-1_2961_11646)"
      >
        <g transform="matrix(3.44128e-10 0.025 -0.025 4.01344e-09 40.5 44)">
          <foreignObject height="2040" width="2040" x="-1020" y="-1020">
            <div
              style={{
                background:
                  'conic-gradient(from 90deg,rgba(255, 255, 255, 0.5692) 0deg,rgba(255, 255, 255, 0.8) 34.616deg,rgba(255, 255, 255, 0.2) 72.6934deg,rgba(255, 255, 255, 0.8) 124.617deg,rgba(255, 255, 255, 0.2) 304.62deg,rgba(255, 255, 255, 0.5692) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M30.7607 67.046L30.563 67.5053L30.5631 67.5053L30.7607 67.046ZM17.454 53.7351L16.9946 53.9325L16.9946 53.9326L17.454 53.7351ZM17.454 34.2389L16.9946 34.0415L16.9946 34.0416L17.454 34.2389ZM30.7649 20.9715L30.566 20.5127L30.566 20.5127L30.7649 20.9715ZM50.2611 20.9715L50.46 20.5127L50.4599 20.5127L50.2611 20.9715ZM63.5285 34.2486L63.9874 34.0501L63.9874 34.0501L63.5285 34.2486ZM58.1825 61.6758L58.537 62.0284L58.537 62.0284L58.1825 61.6758ZM50.2514 67.0346L50.4494 67.4937L50.4494 67.4937L50.2514 67.0346ZM40.4991 69V68.5C37.0996 68.5 33.921 67.8612 30.9582 66.5867L30.7607 67.046L30.5631 67.5053C33.657 68.8362 36.9707 69.5 40.4991 69.5V69ZM30.7607 67.046L30.9583 66.5868C27.9865 65.3081 25.3907 63.557 23.1669 61.3331L22.8133 61.6867L22.4598 62.0402C24.7757 64.3561 27.4781 66.1779 30.563 67.5053L30.7607 67.046ZM22.8133 61.6867L23.1669 61.3331C20.9431 59.1094 19.192 56.5122 17.9133 53.5376L17.454 53.7351L16.9946 53.9326C18.322 57.0204 20.1438 59.7243 22.4598 62.0402L22.8133 61.6867ZM17.454 53.7351L17.9133 53.5377C16.6389 50.5716 16 47.3898 16 43.987H15.5H15C15 47.5185 15.6638 50.8354 16.9946 53.9325L17.454 53.7351ZM15.5 43.987H16C16 40.5843 16.6389 37.4024 17.9133 34.4363L17.454 34.2389L16.9946 34.0416C15.6638 37.1386 15 40.4555 15 43.987H15.5ZM17.454 34.2389L17.9133 34.4364C19.1918 31.4622 20.9425 28.8758 23.1653 26.6727L22.8133 26.3175L22.4613 25.9624C20.1444 28.2588 18.3222 30.9533 16.9946 34.0415L17.454 34.2389ZM22.8133 26.3175L23.1653 26.6727C25.3895 24.4681 27.9877 22.7206 30.9638 21.4302L30.7649 20.9715L30.566 20.5127C27.4797 21.8509 24.7768 23.6674 22.4613 25.9624L22.8133 26.3175ZM30.7649 20.9715L30.9638 21.4302C33.9295 20.1444 37.1108 19.5 40.513 19.5V19V18.5C36.9809 18.5 33.6634 19.1699 30.566 20.5127L30.7649 20.9715ZM40.513 19V19.5C43.9151 19.5 47.0964 20.1444 50.0622 21.4302L50.2611 20.9715L50.4599 20.5127C47.3625 19.1699 44.0451 18.5 40.513 18.5V19ZM50.2611 20.9715L50.0621 21.4302C53.0379 22.7204 55.6253 24.4675 57.8289 26.6711L58.1825 26.3175L58.536 25.964C56.2401 23.6681 53.5466 21.8511 50.46 20.5127L50.2611 20.9715ZM58.1825 26.3175L57.8289 26.6711C60.0323 28.8745 61.7794 31.465 63.0697 34.4472L63.5285 34.2486L63.9874 34.0501C62.6491 30.957 60.8321 28.2601 58.536 25.964L58.1825 26.3175ZM63.5285 34.2486L63.0696 34.4471C64.3556 37.4196 65 40.6024 65 44.0009H65.5H66C66 40.4723 65.3301 37.1537 63.9874 34.0501L63.5285 34.2486ZM65.5 44.0009H65C65 47.3998 64.3556 50.5778 63.0699 53.5403L63.5285 53.7393L63.9872 53.9384C65.3301 50.8441 66 47.5299 66 44.0009H65.5ZM63.5285 53.7393L63.0699 53.5403C61.7795 56.5134 60.0322 59.1064 57.8279 61.3233L58.1825 61.6758L58.537 62.0284C60.8323 59.72 62.649 57.0219 63.9872 53.9384L63.5285 53.7393ZM58.1825 61.6758L57.8279 61.3232C55.6247 63.5387 53.0347 65.2895 50.0534 66.5755L50.2514 67.0346L50.4494 67.4937C53.5433 66.1591 56.2407 64.3374 58.537 62.0284L58.1825 61.6758ZM50.2514 67.0346L50.0534 66.5755C47.0808 67.8575 43.8978 68.5 40.4991 68.5V69V69.5C44.0275 69.5 47.3459 68.8322 50.4494 67.4937L50.2514 67.0346Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;transform&#34;:{&#34;m00&#34;:6.8825511334580369e-07,&#34;m01&#34;:-50.000007629394531,&#34;m02&#34;:65.50,&#34;m10&#34;:50.000003814697266,&#34;m11&#34;:8.0268855526810512e-06,&#34;m12&#34;:18.999992370605469},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        mask="url(#path-21-inside-1_2961_11646)"
      />
    </g>
    <path
      d="M40.4949 59.6706C41.3853 59.6706 42.1406 59.3571 42.7607 58.7301C43.3805 58.1031 43.7018 57.3386 43.7247 56.4365H37.1806C37.2035 57.3386 37.5391 58.1031 38.1874 58.7301C38.8353 59.3571 39.6045 59.6706 40.4949 59.6706ZM30.5893 52.8169H50.3159C50.7833 52.8169 51.179 52.6539 51.5032 52.3277C51.8273 52.0015 51.9894 51.6034 51.9894 51.1332C51.9894 50.6627 51.8273 50.268 51.5032 49.949C51.179 49.6297 50.7833 49.4701 50.3159 49.4701H49.5763V42.3962C49.5763 39.9776 48.9485 37.7656 47.693 35.7604C46.4374 33.7547 44.6521 32.5307 42.3372 32.0883V30.2104C42.3372 29.692 42.1579 29.2532 41.7991 28.8941C41.4404 28.5353 41.002 28.356 40.484 28.356C39.9431 28.356 39.4884 28.5353 39.12 28.8941C38.752 29.2532 38.5681 29.692 38.5681 30.2104V32.0883C36.2757 32.5307 34.496 33.7101 33.2292 35.6264C31.9624 37.5428 31.3289 39.6787 31.3289 42.0343V49.4701H30.5893C30.122 49.4701 29.7263 49.6331 29.4021 49.9593C29.078 50.2855 28.9159 50.6838 28.9159 51.1544C28.9159 51.6245 29.078 52.019 29.4021 52.338C29.7263 52.6573 30.122 52.8169 30.5893 52.8169Z"
      fill="url(#paint14_linear_2961_11646)"
    />
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="82"
        id="filter0_f_2961_11646"
        width="82"
        x="-8.5"
        y="7"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          mode="normal"
          result="shape"
        />
        <feGaussianBlur
          result="effect1_foregroundBlur_2961_11646"
          stdDeviation="8"
        />
      </filter>
      <clipPath
        id="bgblur_0_2961_11646_clip_path"
        transform="translate(-8.5 -12)"
      >
        <path d="M40.4991 69C37.0352 69 33.789 68.3487 30.7607 67.046C27.7323 65.743 25.0832 63.9565 22.8133 61.6867C20.5435 59.4168 18.757 56.7663 17.454 53.7351C16.1513 50.7035 15.5 47.4542 15.5 43.987C15.5 40.5199 16.1513 37.2705 17.454 34.2389C18.757 31.2078 20.5435 28.5673 22.8133 26.3175C25.0832 24.0678 27.7337 22.2858 30.7649 20.9715C33.7965 19.6572 37.0458 19 40.513 19C43.9801 19 47.2295 19.6572 50.2611 20.9715C53.2922 22.2858 55.9327 24.0678 58.1825 26.3175C60.4322 28.5673 62.2142 31.211 63.5285 34.2486C64.8428 37.2866 65.5 40.5374 65.5 44.0009C65.5 47.4648 64.8428 50.711 63.5285 53.7393C62.2142 56.7677 60.4322 59.4132 58.1825 61.6758C55.9327 63.938 53.289 65.7243 50.2514 67.0346C47.2134 68.3449 43.9626 69 40.4991 69Z" />
      </clipPath>
      <clipPath id="paint13_angular_2961_11646_clip_path">
        <path
          d="M30.7607 67.046L30.563 67.5053L30.5631 67.5053L30.7607 67.046ZM17.454 53.7351L16.9946 53.9325L16.9946 53.9326L17.454 53.7351ZM17.454 34.2389L16.9946 34.0415L16.9946 34.0416L17.454 34.2389ZM30.7649 20.9715L30.566 20.5127L30.566 20.5127L30.7649 20.9715ZM50.2611 20.9715L50.46 20.5127L50.4599 20.5127L50.2611 20.9715ZM63.5285 34.2486L63.9874 34.0501L63.9874 34.0501L63.5285 34.2486ZM58.1825 61.6758L58.537 62.0284L58.537 62.0284L58.1825 61.6758ZM50.2514 67.0346L50.4494 67.4937L50.4494 67.4937L50.2514 67.0346ZM40.4991 69V68.5C37.0996 68.5 33.921 67.8612 30.9582 66.5867L30.7607 67.046L30.5631 67.5053C33.657 68.8362 36.9707 69.5 40.4991 69.5V69ZM30.7607 67.046L30.9583 66.5868C27.9865 65.3081 25.3907 63.557 23.1669 61.3331L22.8133 61.6867L22.4598 62.0402C24.7757 64.3561 27.4781 66.1779 30.563 67.5053L30.7607 67.046ZM22.8133 61.6867L23.1669 61.3331C20.9431 59.1094 19.192 56.5122 17.9133 53.5376L17.454 53.7351L16.9946 53.9326C18.322 57.0204 20.1438 59.7243 22.4598 62.0402L22.8133 61.6867ZM17.454 53.7351L17.9133 53.5377C16.6389 50.5716 16 47.3898 16 43.987H15.5H15C15 47.5185 15.6638 50.8354 16.9946 53.9325L17.454 53.7351ZM15.5 43.987H16C16 40.5843 16.6389 37.4024 17.9133 34.4363L17.454 34.2389L16.9946 34.0416C15.6638 37.1386 15 40.4555 15 43.987H15.5ZM17.454 34.2389L17.9133 34.4364C19.1918 31.4622 20.9425 28.8758 23.1653 26.6727L22.8133 26.3175L22.4613 25.9624C20.1444 28.2588 18.3222 30.9533 16.9946 34.0415L17.454 34.2389ZM22.8133 26.3175L23.1653 26.6727C25.3895 24.4681 27.9877 22.7206 30.9638 21.4302L30.7649 20.9715L30.566 20.5127C27.4797 21.8509 24.7768 23.6674 22.4613 25.9624L22.8133 26.3175ZM30.7649 20.9715L30.9638 21.4302C33.9295 20.1444 37.1108 19.5 40.513 19.5V19V18.5C36.9809 18.5 33.6634 19.1699 30.566 20.5127L30.7649 20.9715ZM40.513 19V19.5C43.9151 19.5 47.0964 20.1444 50.0622 21.4302L50.2611 20.9715L50.4599 20.5127C47.3625 19.1699 44.0451 18.5 40.513 18.5V19ZM50.2611 20.9715L50.0621 21.4302C53.0379 22.7204 55.6253 24.4675 57.8289 26.6711L58.1825 26.3175L58.536 25.964C56.2401 23.6681 53.5466 21.8511 50.46 20.5127L50.2611 20.9715ZM58.1825 26.3175L57.8289 26.6711C60.0323 28.8745 61.7794 31.465 63.0697 34.4472L63.5285 34.2486L63.9874 34.0501C62.6491 30.957 60.8321 28.2601 58.536 25.964L58.1825 26.3175ZM63.5285 34.2486L63.0696 34.4471C64.3556 37.4196 65 40.6024 65 44.0009H65.5H66C66 40.4723 65.3301 37.1537 63.9874 34.0501L63.5285 34.2486ZM65.5 44.0009H65C65 47.3998 64.3556 50.5778 63.0699 53.5403L63.5285 53.7393L63.9872 53.9384C65.3301 50.8441 66 47.5299 66 44.0009H65.5ZM63.5285 53.7393L63.0699 53.5403C61.7795 56.5134 60.0322 59.1064 57.8279 61.3233L58.1825 61.6758L58.537 62.0284C60.8323 59.72 62.649 57.0219 63.9872 53.9384L63.5285 53.7393ZM58.1825 61.6758L57.8279 61.3232C55.6247 63.5387 53.0347 65.2895 50.0534 66.5755L50.2514 67.0346L50.4494 67.4937C53.5433 66.1591 56.2407 64.3374 58.537 62.0284L58.1825 61.6758ZM50.2514 67.0346L50.0534 66.5755C47.0808 67.8575 43.8978 68.5 40.4991 68.5V69V69.5C44.0275 69.5 47.3459 68.8322 50.4494 67.4937L50.2514 67.0346Z"
          mask="url(#path-21-inside-1_2961_11646)"
        />
      </clipPath>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_2961_11646"
        x1="40.5"
        x2="40.5"
        y1="14"
        y2="76"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#77ACFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_2961_11646"
        x1="25.5"
        x2="3.5"
        y1="7"
        y2="7"
      >
        <stop stopColor="#D5E3FF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_2961_11646"
        x1="51.5"
        x2="29.5"
        y1="7"
        y2="7"
      >
        <stop stopColor="#D5E3FF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_2961_11646"
        x1="77.5"
        x2="55.5"
        y1="7"
        y2="7"
      >
        <stop stopColor="#D5E3FF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_2961_11646"
        x1="40.5"
        x2="40.5"
        y1="4"
        y2="76"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#4691F4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint5_linear_2961_11646"
        x1="32.5"
        x2="32.5"
        y1="23"
        y2="73"
      >
        <stop stopColor="#4691F4" />
        <stop offset="1" stopColor="#005EB4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint6_linear_2961_11646"
        x1="62.5"
        x2="68.2884"
        y1="45"
        y2="48.5779"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint7_linear_2961_11646"
        x1="61.7917"
        x2="70.9937"
        y1="23"
        y2="24.4054"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint8_linear_2961_11646"
        x1="35.7917"
        x2="44.9937"
        y1="23"
        y2="24.4054"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint9_linear_2961_11646"
        x1="9.79166"
        x2="18.9937"
        y1="23"
        y2="24.4054"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint10_linear_2961_11646"
        x1="9.79166"
        x2="18.9937"
        y1="45"
        y2="46.4054"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint11_linear_2961_11646"
        x1="10.5"
        x2="16.2884"
        y1="67"
        y2="70.5779"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint12_linear_2961_11646"
        x1="40.5"
        x2="40.5"
        y1="19"
        y2="69"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#77ACFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint14_linear_2961_11646"
        x1="40.4526"
        x2="32.493"
        y1="28.356"
        y2="57.4964"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
    </defs>
  </svg>
)
